import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiscalApprovalSettingsComponent } from './fiscal-approval-settings/fiscal-approval-settings.component';
import { DirectivesModule } from '../directives/directives.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FiscalApprovalSettingsComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class FiscalApprovalSettingsModule {
  customElementComponent: Type<any> = FiscalApprovalSettingsComponent;
 }
